/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useTranslation } from "react-i18next";
import { Icons } from "../../components/icons";
import { Badge } from "../../components/ui/badge";
import { Card, CardContent } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import fetchData from "../../utils/api";
import { Config } from "../../utils/config";
import MenuItem from "./MenuItem";
import Coupons from "./Coupons";
import ErrorBoundary from "../../ErrorBoundary"; // Import your ErrorBoundary component

export default function Menu({
  authToken,
  id,
  setCartTotal,
  restaurantDetail,
  isDineIn,
  selectedType,
  setSelectedType,
  setRestaurantDetail,
  setSelectedCategory,
  selectedCategory,
  setMenuCategories,
}) {
  const { t } = useTranslation();
  const [isRefreshing, setIsRefreshing] = React.useState(false);
  const [isOpen, setOpen] = React.useState<boolean>(false);
  const [updatedData, setUpdateData] = React.useState<any>();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [menuList, setMenuList] = React.useState<any>([]);
  const [couponList, setCouponList] = React.useState<any>([]);
  const [cartId, setCartId] = React.useState<any>("");
  const [isMenuNotFound, setIsMenuNotFound] = React.useState(false);
  const [orderingMethod, setOrderingMethod] = React.useState<any>(
    selectedType === "delivery"
      ? "deliveryPrice"
      : selectedType === "pickup"
      ? "pickupPrice"
      : "dineInPrice"
  );
  const [sizesOrderingMethod, setSizesOrderingMethod] = React.useState<any>(
    selectedType === "delivery"
      ? "delivery_price"
      : selectedType === "pickup"
      ? "pickup_price"
      : "dine_in_price"
  );

  React.useEffect(() => {
    setOrderingMethod(
      selectedType === "delivery"
        ? "deliveryPrice"
        : selectedType === "pickup"
        ? "pickupPrice"
        : "dineInPrice"
    );
    setSizesOrderingMethod(
      selectedType === "delivery"
        ? "delivery_price"
        : selectedType === "pickup"
        ? "pickup_price"
        : "dine_in_price"
    );
  }, [selectedType]);

  const handleMenuList = async () => {
    let cachedCart = localStorage.getItem("cart");

    try {
      const body: any = { cart_id: cachedCart };
      const res = await fetchData({
        url: "menu",
        method: "POST",
        body,
        token: authToken,
      });
      if (res.status_code === 200 && res.message !== "menu.not_found") {
        setLoading(false);
        setMenuList(res.data.menu);
        setMenuCategories(res.data.menu.containerOrder);
        setCouponList(res.data.coupons);
        localStorage.setItem("cart", res.data.cart.id);
        setCartId(res.data.cart.id);
        cachedCart = localStorage.getItem("cart");
        if (cachedCart !== null) {
          const bodyData = {
            cart_id: cachedCart,
          };
          const cartItemTotal = await fetchData({
            url: "cart/total",
            method: "POST",
            body: bodyData,
            token: authToken,
          });
          if (cartItemTotal.status_code === 200) {
            setCartTotal(cartItemTotal.data);
          }

          const restaurantDetail = await fetchData({
            url: "restaurant",
            method: "POST",
            token: authToken,
          });
          if (restaurantDetail.status_code === 200) {
            setRestaurantDetail(restaurantDetail.data);
          }
        }
      } else if (res.status_code === 200 && res.message === "menu.not_found") {
        setIsMenuNotFound(true);
        setLoading(false);
        setMenuList([]);
        setCouponList([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  React.useEffect(() => {
    handleMenuList();
  }, []);

  const handlePullToRefresh = async () => {
    setIsRefreshing(true);
    handleMenuList();
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsRefreshing(false);
  };

  let initialTouchY = 0;

  // Function to handle the scroll
  const scrollToElement = () => {
    const element = document.getElementById(selectedCategory);
    if (element) {
      // Scroll the element into view with smooth scrolling
      element.scrollIntoView({ behavior: "smooth", block: "start" });

      // Add margin manually by adjusting scroll position (optional)
      // window.scrollBy(0, 60); // Adjust the margin as needed (50px)
    }
  };

  React.useEffect(() => {
    scrollToElement();
  }, [selectedCategory]);

  return (
    <div
      className="container"
      onTouchStart={(e) => {
        initialTouchY = e.touches[0].clientY; // Record the initial touch position
      }}
      onTouchMove={(e) => {
        // Only trigger the refresh if the user has pulled down
        const currentTouchY = e.touches[0].clientY;
        if (
          currentTouchY > initialTouchY &&
          currentTouchY - initialTouchY > 50 &&
          !isRefreshing
        ) {
          handlePullToRefresh();
        }
      }}
    >
      <ErrorBoundary>
        <div
          className={` flex items-center justify-center bg-background transition-all duration-300 ${
            isRefreshing
              ? "h-[60px] opacity-100"
              : "h-0 opacity-0 pointer-events-none"
          }`}
        >
          {isRefreshing ? (
            <div className="h-6 w-6 text-primary">
              <Icons.spinner className=" size-7 animate-spin" />
            </div>
          ) : null}
        </div>
      </ErrorBoundary>

      {loading ? (
        <ErrorBoundary>
          <div className="h-[70dvh] flex justify-center items-center flex-col">
            <Icons.spinner className="size-5 animate-spin" />
            <h2>{t("please_wait")}</h2>
            <p className="text-sm mt-2 text-center">
              {t("order_history.did_you_know")}
            </p>
          </div>
        </ErrorBoundary>
      ) : (
        !isMenuNotFound && (
          <div className="flex gap-5 justify-center items-center ">
            <div className="w-full space-y-4 sm:space-y-8">
              <h2 className="relative z-[1] text-2xl sm:text-3xl lg:text-4xl font-medium text-black">
                {t("menu.title")}
              </h2>

              {couponList && couponList.length > 0 && (
                <ErrorBoundary>
                  <Coupons
                    couponList={couponList}
                    currency={restaurantDetail?.currencyDetails?.symbol}
                    menuList={menuList}
                    restaurantDetail={restaurantDetail}
                    isDineIn={isDineIn}
                    selectedType={selectedType}
                    orderingMethod={orderingMethod}
                    sizesOrderingMethod={sizesOrderingMethod}
                    setSelectedType={setSelectedType}
                    cartId={cartId}
                    authToken={authToken}
                    setCartTotal={setCartTotal}
                    id={id}
                  />
                </ErrorBoundary>
              )}

              {menuList.containerOrder.map((containerId, index) => {
                const container = menuList.containers[containerId.id];
                if (container.visibility === 0) return null;
                const containerCategory = container.items[0];
                return (
                  <ErrorBoundary key={index}>
                    <div
                      className="space-y-2 sm:space-y-4 !scroll-mt-[220px] sm:!scroll-mt-48"
                      id={container?.title}
                    >
                      {container?.categoryImage ? (
                        <div
                          className="relative h-[110px] sm:h-[178px] flex justify-center items-center bg-cover bg-center rounded-lg overflow-hidden"
                          style={{
                            backgroundImage: `url(${
                              Config.env.app.image_url
                            }/${container?.categoryImage.replace("//", "/")})`,
                          }}
                        >
                          <div className="absolute inset-0 bg-black/40"></div>
                          <Label className="relative z-[1] text-xl lg:text-2xl font-bold text-white">
                            {container?.title}
                          </Label>
                        </div>
                      ) : (
                        <h3 className="text-red text-2xl lg:text-3xl font-semibold">
                          {container?.title}
                        </h3>
                      )}
                      <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,_minmax(330px,_1fr))] gap-2 sm:gap-4">
                        {container.items.map((menu, index) => {
                          const isMenuItemTiming = menu.is_available;
                          if (menu.visibility === 0) return null;
                          if (menu[orderingMethod] === null) {
                            if (
                              menu?.sizes[0][sizesOrderingMethod] === "0.00"
                            ) {
                              return null;
                            }
                          }

                          if (menu[orderingMethod] === "0.00") {
                            return null;
                          }

                          if (menu.availability !== "in_stock") {
                            return null;
                          }

                          return (
                            <ErrorBoundary key={index}>
                              <div
                                onClick={() => {
                                  if (
                                    menu.availability === "in_stock" &&
                                    isMenuItemTiming
                                  ) {
                                    setUpdateData(menu), setOpen(true);
                                  }
                                }}
                                className={`space-y-2 ${
                                  menu.availability === "in_stock" &&
                                  isMenuItemTiming
                                    ? "cursor-pointer"
                                    : "cursor-not-allowed"
                                }`}
                              >
                                <Card className="p-3.5 bg-white flex items-center h-full gap-2">
                                  {menu.image && (
                                    <div className="flex-shrink-0 size-20">
                                      <img
                                        src={`${
                                          Config.env.app.image_url
                                        }/${menu.image.replace("//", "/")}`}
                                        alt="menu"
                                        className="h-full w-full rounded-md object-cover"
                                      />
                                    </div>
                                  )}
                                  <div className="w-full flex flex-col h-full gap-1.5">
                                    <div className="flex items-center gap-1">
                                      {menu.availability !== "in_stock" && (
                                        <Badge variant="destructive">
                                          {t("out_of_stock")}
                                        </Badge>
                                      )}
                                      {!isMenuItemTiming && (
                                        <Badge variant="destructive">
                                          {t("not_available")}
                                        </Badge>
                                      )}
                                    </div>
                                    <h4 className="font-bold text-lg leading-[1.2] line-clamp-2">
                                      {menu?.name?.toString()}
                                    </h4>
                                    <p className="mb-auto text-gray-500 leading-[1.2] line-clamp-2">
                                      {menu?.itemDescription?.toString()}
                                    </p>
                                    <div>
                                      <p className="text-lg font-bold leading-[1.2]">
                                        {selectedType !== "" &&
                                          (isDineIn
                                            ? menu?.dineInPrice === null
                                              ? `${
                                                  restaurantDetail
                                                    ?.currencyDetails?.symbol
                                                } ${parseFloat(
                                                  menu?.sizes[0].dine_in_price
                                                ).toFixed(2)} `
                                              : `${
                                                  restaurantDetail
                                                    ?.currencyDetails?.symbol
                                                } ${parseFloat(
                                                  menu?.dineInPrice
                                                ).toFixed(2)} `
                                            : menu[orderingMethod] === null
                                            ? `${
                                                restaurantDetail
                                                  ?.currencyDetails?.symbol
                                              } ${parseFloat(
                                                menu?.sizes[0][
                                                  sizesOrderingMethod
                                                ]
                                              ).toFixed(2)}`
                                            : `${
                                                restaurantDetail
                                                  ?.currencyDetails?.symbol
                                              } ${parseFloat(
                                                menu[orderingMethod]
                                              ).toFixed(2)}`)}
                                      </p>
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            </ErrorBoundary>
                          );
                        })}
                      </div>
                    </div>
                  </ErrorBoundary>
                );
              })}

              <ErrorBoundary>
                <MenuItem
                  isOpen={isOpen}
                  setOpen={() => setOpen(!isOpen)}
                  updateData={updatedData}
                  cartId={cartId}
                  id={id}
                  authToken={authToken}
                  setCartTotal={setCartTotal}
                  restaurantDetail={restaurantDetail}
                  isDineIn={isDineIn}
                  selectedType={selectedType}
                  setSelectedType={setSelectedType}
                  orderingMethod={orderingMethod}
                  sizesOrderingMethod={sizesOrderingMethod}
                />
              </ErrorBoundary>
            </div>
          </div>
        )
      )}

      {isMenuNotFound && (
        <ErrorBoundary>
          <Card>
            <CardContent>
              <div className="flex justify-center">
                <Label>{t("menu.not_found")}</Label>
              </div>
            </CardContent>
          </Card>
        </ErrorBoundary>
      )}
    </div>
  );
}
